<div class="shopping-list">
  @if (items().length || isMobile()) {
    <div class="control-panel" [class.desktop-view]="!isMobile()">
      @if (isMobile()) {
        <ui-toolbar-button
          (clicked)="openAddToShoppingListQuickMobile.emit()"
          icon="plus"
          iconStyle="light"
          [disabled]="mobileSelectionVisible()">
          Hinzufügen
        </ui-toolbar-button>

        @if (isCapacitorApp()) {
          <ui-toolbar-button
            (clicked)="openScanner.emit()"
            icon="barcode"
            iconStyle="light"
            [disabled]="mobileSelectionVisible()">
            Scannen
          </ui-toolbar-button>
        }

        <ui-toolbar-button
          [disabled]="!items().length"
          icon="ballot-check" iconStyle="light"
          (clicked)="toggleShift()">
          {{ mobileSelectionVisible() ? 'Ausblenden' : 'Auswählen' }}
        </ui-toolbar-button>

        @if (shoppingListDownloadEnabled()) {
          <ui-icon-button
            class="download-button"
            (clicked)="download.emit()"
            buttonStyle="tonal"
            icon="download"
            iconStyle="light"
            tooltip="CSV herunterladen"
            [loading]=isDownloading()
          ></ui-icon-button>
        }
      } @else {
        @if (!hasSingleCategory()) {
          <ui-product-categories-filter
            [(selectedNodes)]="selectedNodes"
            [nodes]="nodes()">
          </ui-product-categories-filter>
        }

        <div class="wrapper-checkbox-and-download">
          @if (items().length > 1) {
            <mat-checkbox (change)="selectAll($event.checked)" [checked]="allSelectedChecked()">
              <mat-label>Alle auswählen</mat-label>
            </mat-checkbox>
          }

          @if (shoppingListDownloadEnabled()) {
            <ui-icon-button
              (clicked)="download.emit()"
              buttonStyle="tonal"
              icon="download"
              iconStyle="light"
              tooltip="CSV herunterladen"
              [loading]=isDownloading()
            ></ui-icon-button>
          }
        </div>
      }
    </div>
  }

  @if (items().length) {
    <div [hidden]="mobileSelectionVisible()" class="grouped-item-list">
      @if (isMobile() && !hasSingleCategory()) {
        <ui-product-categories-filter
          [(selectedNodes)]="selectedNodes"
          [nodes]="nodes()">
        </ui-product-categories-filter>
      }

      <ng-content></ng-content>

      @for (topLevelCategory of visibleNodes(); track topLevelCategory.id) {
        @if (hasSingleCategory()) {
          @for (secondLevelCategory of topLevelCategory.children; track secondLevelCategory.id; let first = $first) {
            <p class="sub-category-header" [class.first]="first">{{ secondLevelCategory.label }}</p>
            @defer (on viewport) {
              <div class="shopping-list-items">
                @for (item of secondLevelCategory.items; track item.quantity + item.id) {
                  @let selected = selectedItems().includes(item);
                  <ui-shopping-list-item
                    [selected]="selected"
                    [showCheckbox]="!isMobile()"
                    (selectedChange)="itemSelectionChanged(item,$event)"
                    [product]="item.productData"
                    [shoppingListItem]="item"
                    (quantityChanged)="onItemQuantityChanged($event)"
                    (removed)="onItemRemoved($event)"
                    uiProductImpression
                    [position]="itemPositions().get(item) ?? 0"
                  ></ui-shopping-list-item>
                }
              </div>
            } @placeholder (minimum 400ms) {
              <div class="shopping-list-items">
                @for (_ of skeletonRenderArray(); track $index) {
                  <ui-shopping-list-item-skeleton [displayListView]="!isMobile()"></ui-shopping-list-item-skeleton>
                }
              </div>
            }
          }
        } @else {
          <ui-expander
            [expanded]="expandedMap().get(topLevelCategory.label) ?? true"
            (expandedChange)="categoryExpandedChanged($event,topLevelCategory)"
            [title]="topLevelCategory.label"
          >
            @for (secondLevelCategory of topLevelCategory.children; track secondLevelCategory.id; let first = $first) {
              <p class="sub-category-header" [class.first]="first">{{ secondLevelCategory.label }}</p>
              @defer (on viewport) {
                <div class="shopping-list-items">
                  @for (item of secondLevelCategory.items; track item.quantity + item.id) {
                    @let selected = selectedItems().includes(item);
                    <ui-shopping-list-item
                      [selected]="selected"
                      [showCheckbox]="!isMobile()"
                      (selectedChange)="itemSelectionChanged(item,$event)"
                      [product]="item.productData"
                      [shoppingListItem]="item"
                      (quantityChanged)="onItemQuantityChanged($event)"
                      (removed)="onItemRemoved($event)"
                      uiProductImpression
                      [position]="itemPositions().get(item) ?? 0"
                    ></ui-shopping-list-item>
                  }
                </div>
              } @placeholder (minimum 400ms) {
                <div class="shopping-list-items">
                  @for (_ of skeletonRenderArray(); track $index) {
                    <ui-shopping-list-item-skeleton [displayListView]="!isMobile()"></ui-shopping-list-item-skeleton>
                  }
                </div>
              }
            }
          </ui-expander>
        }
      }
    </div>
  }

  <div class="items-list">
    @if (mobileSelectionVisible()) {
      <ui-mobile-selection-wrapper
        [allItemsChecked]="allSelectedChecked()"
        [selectionVisible]="mobileSelectionVisible()"
        (selectAll)="selectAll($event)"
        (closeSelection)="toggleShift()"
      >
        @for (item of visibleItems(); track item.quantity + item.id) {
          @defer (on viewport) {
            @let selected = selectedItems().includes(item);
            <ui-mobile-selection-item
              (selectedChange)="itemSelectionChanged(item,$event)"
              [selected]="selected"
              [selectionVisible]="mobileSelectionVisible()"
            >
              <ui-shopping-list-item
                [selected]="selected"
                [showCheckbox]="false"
                (selectedChange)="itemSelectionChanged(item,$event)"
                [product]="item.productData"
                [shoppingListItem]="item"
                (quantityChanged)="onItemQuantityChanged($event)"
                (removed)="onItemRemoved($event)"
              ></ui-shopping-list-item>
            </ui-mobile-selection-item>
          } @placeholder {
            <span></span>
          }
        }
      </ui-mobile-selection-wrapper>
    }
  </div>
</div>

@if (!items().length) {
  @if (noItemsElement(); as noItemsElement) {
    <ng-container *ngTemplateOutlet="noItemsElement"></ng-container>
  } @else {
    <div class="container-no-items">
      <h3>Noch keine Artikel vorhanden.</h3>
    </div>
  }
}

<ng-template #actions>
  <ui-shopping-list-actions
    [isMobile]="isMobile()"
    [selectedLength]="selectedItems().length"
    (addToCart)="emitAddToCartSelectedItems()"
    (removeItems)="emitRemoveSelectedItems()">
  </ui-shopping-list-actions>
</ng-template>
